import { createElement, lazy, Suspense, FC } from 'react';
import { Redirect, Route, Switch } from 'react-router';
import User from '../../entity/User';

const WorksListPage = lazy(() => import('../connected/WorksListPage'));
const ConfigurationPage = lazy(() => import('../connected/ConfigurationPage'));

type Props = {
  user: User | null;
  className?: string;
};

const SignedInScreen: FC<Props> = ({ className, user }) => (
  <div className={className}>
    <Suspense fallback={<div />}>
      <Switch>
        <Route exact sensitive path="/users/:userId" component={WorksListPage} />
        <Route exact sensitive path="/users/:userId/works/:workId" component={WorksListPage} />
        <Route exact sensitive path="/settings" component={ConfigurationPage} />
        {user && user.id && <Redirect from="/" to={`/users/${user.id}`} />}
      </Switch>
    </Suspense>
  </div>
);

export default SignedInScreen;
